<template>
    <div>
        <div class="Nav">
            <div class="Nav_top">
                <!-- <router-link to="/writing/titleGeneration/titleGeneration" active-class="active" :class="{'active': $route.meta.requiresAuth}"  class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img/sv30.svg"/><img src="@a/img/sv30on.svg"/></span>
                    </div>
                    <div class="top_list_title">SEO软文</div>
                </router-link> -->
                <router-link to="/copyWriting" active-class="active" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img/sv31.svg"/><img src="@a/img/sv31on.svg"/></span>
                    </div>
                    <div class="top_list_title">文案创作</div>
                </router-link>
                <!-- <router-link to="/chatDog" active-class="active" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img/sv62.svg"/><img src="@a/img/sv62on.svg"/></span>
                    </div>
                    <div class="top_list_title">ChatDOG</div>
                </router-link>
                <router-link to="/alRobot" active-class="active" class="Nav_top_list">
                    <div class="top_list_icon">
                        <span><img src="@a/img/sv66.svg"/><img src="@a/img/sv66on.svg"/></span>
                    </div>
                    <div class="top_list_title">AI机器人</div>
                </router-link> -->
            </div>
        </div>
        <div class="writing_nav2">
            <div class="writing_nav_con">
                <div class="AIPackage">
                    <div class="AIPackage_title font14">免费版会员</div>
                    <div class="AIPackage_time font26">364天</div>
                    <div class="AIPackage_timedd font12">会员剩余天数</div>
                    <div class="AIPackage_timedt font12">2026年02月12日到期</div>
                    <div class="AIPackage_btn font12">开通会员，享受更多权益</div>
                </div>
                <div class="writing_nav_list" :class="{ 'active': $route.meta.requiresA }">
                    <router-link to="/writing/titleGeneration/titleGeneration" active-class="active"
                        class="nav_list_title"><span><img src="@a/img2/sv68.svg" /><img
                                src="@a/img2/sv68on.svg" /></span>文章生成</router-link>
                    <div class="nav_list_down">
                        <router-link to="/writing/titleGeneration/titleGeneration" active-class="active">
                            手动生成
                        </router-link>
                        <router-link to="/writing/titleGeneration/BackgroundHostingCreate" active-class="active"
                            :class="{ 'active': $route.meta.requiresC }">
                            批量生成
                        </router-link>
                    </div>
                </div>
                <div class="writing_nav_list">
                    <router-link to="/writing/myArticles" active-class="active" class="nav_list_title"><span><img
                                src="@a/img2/sv69.svg" /><img src="@a/img2/sv69on.svg" /></span>我的文章</router-link>
                </div>
                <div class="writing_nav_list">
                    <router-link to="/writing/planTorelease" active-class="active" class="nav_list_title"><span><img
                                src="@a/img2/sv70.svg" /><img src="@a/img2/sv70on.svg" /></span>计划发布</router-link>
                </div>
                <div class="writing_nav_list">
                    <router-link to="/writing/siteManagement" active-class="active" class="nav_list_title"><span><img
                                src="@a/img2/sv71.svg" /><img src="@a/img2/sv71on.svg" /></span>站点管理</router-link>
                </div>
                <div class="writing_nav_list">
                    <router-link to="/writing/releaselog" active-class="active" class="nav_list_title"><span><img
                                src="@a/img2/sv72.svg" /><img src="@a/img2/sv72on.svg" /></span>发布日志</router-link>
                </div>
                <div class="writing_nav_list">
                    <router-link to="/writing/pictureManagement" active-class="active" class="nav_list_title"><span><img
                                src="@a/img2/sv73.svg" /><img src="@a/img2/sv73on.svg" /></span>图片管理</router-link>
                </div>
                <div class="writing_nav_list">
                    <router-link to="/writing/ProhibitedWords" active-class="active" class="nav_list_title"><span><img
                                src="@a/img2/sv74.svg" /><img src="@a/img2/sv74on.svg" /></span>违禁词管理</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "nav",
    data() {
        return {

        };
    },
    computed: {

    },
    methods: {

    },
}
</script>

<style scoped>
@import "CopywritingNav2.css";
</style>